module.exports = __webpack_public_path__ + "static/city-1ea8f925c98202d5e09c910017909a76.gif";